import { apiRequest } from '@/core';

export const logoutRequest = async () =>
  apiRequest<void>({
    endpoint: 'logout',
    method: 'POST',
  });
